export const useBaseUrl = () => {
  // Infer the API baseUrl by interpolating the current location's href,
  // thereby relying on our host-naming convention to be at play, see examples below:
  //
  // 1) prod: termine.ista-express.de     -> api.ista-express.de
  // 2) dev : termine-dev.ista-express.de -> api-dev.ista-express.de
  const apiHostName = window.location.host.replace('termine', 'api')

  const baseUrl = `${window.location.protocol}//${apiHostName}`
  return { baseUrl, apiHostName }
}
